import { Failure } from '@mrhenry/failure';
import { html, TemplateResult } from 'lit';
import { live } from 'lit/directives/live.js';
import { classMap } from 'lit/directives/class-map.js';
import { Dispatcher } from '../../../types/booking-request';
import { staticText } from '../../../static-text';

export function telephoneInput(
	telephone: string,
	dispatch: Dispatcher,
	assetUrl: string,
	telephoneFailure?: Failure
): TemplateResult {
	const changeHandler = ( e: InputEvent ) => {
		if ( e.target !== e.currentTarget ) {
			return;
		}

		if ( !( e.target instanceof HTMLInputElement ) ) {
			throw new Error( 'e.target should be instanceof HTMLInputElement' );
		}

		const value = e.target.value;
		if ( !value || '' === value ) {
			dispatch( {
				type: 'UPDATE_TELEPHONE',
				telephone: value,
				telephoneFailure: Failure.from( staticText.telephoneIsRequiredFailureMessage ),
			} );

			return;
		}

		dispatch( {
			type: 'UPDATE_TELEPHONE',
			telephone: value,
		} );
	};

	const classes = {
		'has-error': Failure.isFailure( telephoneFailure ),
	};

	let failure = html``;
	if ( Failure.isFailure( telephoneFailure ) ) {
		failure = html`
			<p class="form__field-validation-error theme-color-error">
				<img alt="" class="form__field-validation-error__icon" src="${assetUrl}/assets/images/alert-circle.svg">
				${telephoneFailure?.message}
			</p>
		`;
	}

	return html`
		<div class="form__row ${classMap( classes )}">
			<div class="form__label-container type-d">
				<label class="form__label" for="telephone">
					${staticText.telephoneRequired}
				</label>
			</div>

			<input
				.value=${live( telephone )}
				@change=${changeHandler}
				class="form__input"
				id="telephone"
				name="telephone"
				type="text"
			/>

			${failure}
		</div>
	`;
}
